import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["disabled", "use", "weight"];
import { useTheme } from 'foundations-theming/utils';
import { USES, WEIGHTS } from '../../utils/TextElementConstants';
import { AbstractElement } from '../AbstractElement/AbstractElement';
import { AbstractTextElementProvider } from './AbstractTextElementProvider';
import { deepMerge } from '../../utils/deepMerge';
import { useSmallContext } from '../Small/SmallContextProvider';
import { useBigContext } from '../Big/BigContextProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export const AbstractTextElement = _ref => {
  var _smallContext$abstrac, _bigContext$abstractT;
  let {
      disabled,
      use,
      weight
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const smallContext = useSmallContext();
  const bigContext = useBigContext();
  const abstractElementStylesOverrides = Object.assign({}, disabled && {
    color: 'gray'
  }, !disabled && Object.assign({}, weight === WEIGHTS.regular && {
    fontWeight: '400'
  }, weight === WEIGHTS.medium && {
    fontWeight: theme.typography['heading-400'].fontWeight
  }, weight === WEIGHTS.demi && {
    fontWeight: theme.typography['heading-300'].fontWeight
  }, weight === WEIGHTS.bold && {
    fontWeight: theme.typography['heading-600'].fontWeight
  }, use === USES.error && {
    color: theme.color['text-alert-default']
  }, use === USES.help && {
    color: theme.color['text-core-subtle']
  }, use === USES.success && {
    color: theme.color['fill-positive-pressed']
  }));
  return /*#__PURE__*/_jsx(AbstractTextElementProvider, {
    abstractElementStylesOverrides: deepMerge(abstractElementStylesOverrides, (_smallContext$abstrac = smallContext === null || smallContext === void 0 ? void 0 : smallContext.abstractTextElementStyleOverrides) !== null && _smallContext$abstrac !== void 0 ? _smallContext$abstrac : {}, (_bigContext$abstractT = bigContext === null || bigContext === void 0 ? void 0 : bigContext.abstractTextElementStyleOverrides) !== null && _bigContext$abstractT !== void 0 ? _bigContext$abstractT : {}),
    children: /*#__PURE__*/_jsx(AbstractElement, Object.assign({}, restProps))
  });
};